import firebase from "firebase/compat/app"
import "firebase/compat/firestore"

const firebaseConfig = {

    apiKey: "AIzaSyDb68QgEG50LtQxeQXXD49ZZY16jDwAUgc",
  
    authDomain: "catasco-appointment.firebaseapp.com",
  
    projectId: "catasco-appointment",
  
    storageBucket: "catasco-appointment.appspot.com",
  
    messagingSenderId: "728038794020",
  
    appId: "1:728038794020:web:04e91febe10017ab9449b1"
  
  };
  

const app = firebase.initializeApp(firebaseConfig);

const db = app.firestore();

export default db